import { useDetailsResource } from 'framework/ViewTypes/hooks';
import { useParams } from 'react-router-dom';
import useApplicationDetailsService from './useApplicationDetailsService';

const useApplicationDetailsData = () => {
  const { getApplication } = useApplicationDetailsService();
  const { id } = useParams<Dictionary<string>>();

  const { data: application, ...state } = useDetailsResource(id, applicationId =>
    getApplication(Number(applicationId)),
  );
  return { application, ...state };
};

export default useApplicationDetailsData;
